import { render, staticRenderFns } from "./Delivered-CompanyProfile.vue?vue&type=template&id=5b91e424&"
import script from "./Delivered-CompanyProfile.vue?vue&type=script&lang=js&"
export * from "./Delivered-CompanyProfile.vue?vue&type=script&lang=js&"
import style0 from "./Delivered-CompanyProfile.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports